import './style/header.scss';

import React, {useContext} from 'react';
import {VEHICLE_STORAGE_KEY, VEHICLES_ROUTE} from '../../util/constants';
import {saveInStorage} from '../../util/storageUtil';
import {AppContext} from '../context/appContext';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import {getVehicleIcon, getVehicleLabel} from '../../util/utils';
import {useNavigate} from 'react-router';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';

export default function Header() {
    const {vehicleContext, onChangeContext, userContext} = useContext(AppContext);
    const {vehicle, vehicles} = vehicleContext;
    const {user} = userContext;
    const navigate = useNavigate();

    function onClickVehicle() {
        navigate(VEHICLES_ROUTE);
    }

    function onClickVehicleControl(direction: 'prev' | 'next') {
        return function (evt: React.MouseEvent) {
            evt.stopPropagation();
            if (!vehicle) return;
            const currentIndex = vehicles.indexOf(vehicle);
            if (currentIndex === -1) return;
            let nextIndex: number;
            if (direction === 'prev') {
                if (currentIndex === 0) nextIndex = vehicles.length - 1;
                else nextIndex = currentIndex - 1;
            } else {
                if (currentIndex === vehicles.length - 1) nextIndex = 0;
                else nextIndex = currentIndex + 1;
            }
            const nextVehicle = vehicles[nextIndex];
            saveInStorage(VEHICLE_STORAGE_KEY, nextVehicle.id);
            onChangeContext({vehicle: nextVehicle});
        };
    }

    function renderVehicle() {
        if (!user) return null;
        return (
            <div className={classNames('vehicle-row', vehicles.length > 1 && 'with-controls')} onClick={onClickVehicle}>
                {renderVehicleControl('prev')}
                <label className='vehicle-label'><AwesomeIcon name={getVehicleIcon(vehicle)}/> {getVehicleLabel(
                    vehicle)}</label>
                {renderVehicleControl('next')}
            </div>
        );
    }

    function renderVehicleControl(direction: 'prev' | 'next') {
        if (vehicles.length <= 1) return null;
        const iconName: IconName = direction === 'prev' ? 'chevron-left' : 'chevron-right';
        return (
            <AwesomeIcon name={iconName} className='vehicle-control' onClick={onClickVehicleControl(direction)}/>
        );
    }

    return (
        <div className='application-header'>
            <label>Kilometer registratie</label>
            {renderVehicle()}
        </div>
    );
}